import React from 'react';
import { IconButton, Stack } from '@mui/material';
import { CampaignDto } from '@shared/services/apiService/apiService';
import { IconActionPlay, IconActionStop } from '@shared/assets/images/svgs';
import { getCampaignStatus } from './utils';
import { ActionTableButton } from '@shared/components/actionTableButton/actionTableButton';

export enum CampaignStatus {
  NotStarted = 'not-started',
  Dialing = 'dialing',
}

type CampaignStatusButtonCampaign = Pick<CampaignDto, 'id' | 'status'> | null | undefined;

interface CampaignStatusButtonProps {
  campaign?: CampaignStatusButtonCampaign;
  disabled?: boolean;
  onClick?: (id: string, campaignStatus: CampaignStatus) => void;
}

const getCampaignStatusFragment = (campaignStatus: CampaignStatus) => {
  if (campaignStatus === CampaignStatus.Dialing) {
    return (
      <ActionTableButton>
        <IconActionStop />
      </ActionTableButton>
    );
  } else if (campaignStatus === CampaignStatus.NotStarted) {
    return (
      <ActionTableButton filled>
        <IconActionPlay />
      </ActionTableButton>
    );
  }
};

const CampaignStatusButton: React.FC<CampaignStatusButtonProps> = ({
  campaign,
  disabled,
  onClick,
}) => {
  const campaignStatus = getCampaignStatus(campaign);

  return (
    <IconButton
      size="small"
      disabled={disabled}
      data-testid={campaign?.id ? `campaign-start-stop-${campaign.id}` : 'campaign-start-stop'}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(campaign?.id as string, campaignStatus);
      }}>
      <Stack alignItems="center" direction="row" gap={1}>
        {getCampaignStatusFragment(campaignStatus)}
      </Stack>
    </IconButton>
  );
};

export default CampaignStatusButton;
